import React from 'react';
import TextShell from './TextShell';
import withPresets from '@xingternal/with-presets';
import * as skins from './bodyCopySkins';

const BodyCopy = ({ ...props }) => <TextShell {...props} />;
export default withPresets(skins)(BodyCopy);
